import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { Link } from "react-router-dom";
import { compose } from "redux";
import { Dropdown, Icon, Label } from "semantic-ui-react";
import { handleNewRequestStatus } from "../../store/actions/superAdminNewRequestStatus";
import PlanCardModal from "../modal/PlanCardModal";

const NewRequestsCard = (props) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const handleApproval = (newStatus, data, oldStatus) => {
    dispatch(handleNewRequestStatus(data, newStatus, oldStatus));
  };

  return (
    <div className="eventDetails-data">
      <h5 className="custom-title">
        {props.data.fname} {props.data.lname}
      </h5>
      <div className="datas">
        <p>Class Year: </p>
        <span>{props.data.classYear}</span>
      </div>
      <div className="datas">
        <p>School:</p>
        <span>{props.data.school}</span>
      </div>
      {props.selectedPlan && props.data.selectedPlan && (
        <div className="datas">
          <p>Payment Plan:</p>
          <span>
            <button className="pdf-icon" onClick={() => setOpen(true)}>
              {props.selectedPlan.amount / 100}
            </button>
          </span>
        </div>
      )}
      {props.data.paymentDone && (
        <div className="datas">
          <p>Payment:</p>
          <span>Sucessfull</span>
        </div>
      )}
      {props.data.mainAgreementUrl && (
        <div className="datas">
          <p>Main Agreement:</p>
          <span>
            <a
              target="_blank"
              rel="noreferrer"
              href={props.data.mainAgreementUrl}
            >
              <button className="pdf-icon">
                <Icon name="file pdf" />
              </button>
            </a>
          </span>
        </div>
      )}
      {props.data.secondAgreementUrl && (
        <div className="datas">
          <p>Second Agreement:</p>
          <span>
            <a
              target="_blank"
              rel="noreferrer"
              href={props.data.secondAgreementUrl}
            >
              <button className="pdf-icon">
                <Icon name="file pdf" />
              </button>
            </a>
          </span>
        </div>
      )}
      <div className="datas">
        <p>Status:</p>
        <Label
          color={
            props.data.status
              ? "teal"
              : props.data.status === null
              ? "yellow"
              : "red"
          }
          tag
        >
          {props.data.status
            ? "Approved"
            : props.data.status === null
            ? "Pending"
            : "Disapprove"}
        </Label>
      </div>
      <div className="event-btn-data">
        <div className="one">
          {/* <button class="ui blue circular icon button"> <Icon name="edit" /></button> */}
          {/* <button className="ui red circular icon button">
            <Icon name="trash" />
          </button> */}
        </div>
        <div className="two">
          <Dropdown
            disabled={!props.data.paymentDone}
            placeholder={
              props.data.status
                ? "Approved"
                : props.data.status === null
                ? "Pending"
                : "Disapprove"
            }
            selection
            onChange={(not, data) =>
              handleApproval(data.value, props.data, props.data.status)
            }
            options={[
              {
                key: 1,
                text: "Approve",
                value: true,
                disabled: props.data.status,
              },
              {
                key: 2,
                text: "Pending",
                value: null,
                disabled: props.data.status === null ? true : false,
              },
              {
                key: 3,
                text: "Disapprove",
                value: false,
                disabled: props.data.status === false ? true : false,
              },
            ]}
          />
        </div>
      </div>
      <div className="event-btn-data abs-btn only-one">
        {/* <button class="ui green circular icon button"><Icon name="user" /></button> */}
        <Link to={`/super-admin/newrequests/${props.data.id}`} target="_blank">
          <button className="ui black basic circular icon button">
            <i aria-hidden="true" className="linkify icon"></i>
          </button>
        </Link>
      </div>
      {props.selectedPlan && props.data.selectedPlan && (
        <PlanCardModal
          plan={props.selectedPlan}
          open={() => setOpen(true)}
          close={() => setOpen(false)}
          hidden={open}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state, { data }) => {
  let selectedPlan = null;
  if (
    Object.keys(data).length > 0 &&
    data.selectedPlan &&
    state.firestore.data.testPriceList &&
    Object.keys(state.firestore.data.testPriceList).length > 0
  ) {
    selectedPlan = state.firestore.data.testPriceList[data.selectedPlan];
  }
  return {
    selectedPlan,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "testPriceList",
      },
    ];
    return firestoreArray;
  })
)(NewRequestsCard);
